export const TR_MAP_STR = `{i:'[iİ]',İ:'[iİ]',ı:'[ıI]',I:'[ıI]',ş:'[şŞ]',Ş:'[şŞ]',ç:'[çÇ]',Ç:'[çÇ]',ö:'[öÖ]',Ö:'[öÖ]',ü:'[üÜ]',Ü:'[üÜ]',ğ:'[ğĞ]',Ğ:'[ğĞ]'}`;
export const TR_RX_FN = `var trMap = ${TR_MAP_STR}; var rx = deger ? Array.from(deger).map(function(c){return trMap[c]||c}).join('') : '';`;

const LOOKUP_ICERIKLER = `{"$lookup":{"from":"hareketler","localField":"veri.icerikler","foreignField":"_id","as":"veri.icerikler"}}`;
const PV_FN = `var ic=scnk.veri?.icerikler?.[0]; var p=(ic?.ek?.parametreler||[]); function _pv(n){var v=(p.find(function(x){return x.ismi===n})||{}).degeri; if(v!=null&&v!=='') return v; var e=ic?.ek; return e?e[n]||'':'';}`;

export function departmanAcilirKutu(ismi: string, baslik: string): any {
  return {
    turu: 'Açılır Kutu', ismi, baslik, ayarlar: {
      arama: true, silme: true, solSimge: '🏢',
      hizliEkle: 'Departman',
      hizliEkleSetId: 'hmi.departman',
      hizliEkleKaynakSetleri: [DEPARTMAN_HIZLI_SET],
      itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: true, resimGoster: false },
      secenekItm: `
        ${PV_FN}
        var adi = _pv('departmanAdi') || ('Departman #' + String(scnk._id).slice(-4));
        var kodu = _pv('departmanKodu');
        return { value: scnk._id, label: adi, simge: '🏢', aciklama: kodu }
      `,
      fapiAyarlar: {
        vt: 'FikoYT.sistem.hareketler',
        uygulama: 'FikoYT.sistem.hmi.yonetim',
        solSimge: { baslik: 'HMI', renkArka: '#722ed1', renkYazi: '#fff' },
        kurdela: { baslik: 'Yönetim' },
        pipeFunc: `${TR_RX_FN}
          var m = { "silindi": {"$ne":true} };
          var pipe = [ {"$match": m}, ${LOOKUP_ICERIKLER}, {"$match":{"veri.icerikler.ek._secilenSetId":"hmi.departman"}} ];
          if (rx) pipe.push({"$match":{"veri.icerikler.ek.parametreler":{"$elemMatch":{"ismi":"departmanAdi","degeri":{"$regex":rx,"$options":"i"}}}}});
          pipe.push({"$sort":{_id:-1}}, {"$limit":20}, {"$project":{_id:1,"veri.icerikler":1}});
          return pipe`,
      },
    }
  };
}

// Tam parametre seti — hızlı ekle'de tüm alanlar gösterilir
const PERSONEL_HIZLI_SET = {
  id: 'hmi.personel', baslik: 'Personel', simge: '👤', kaynak: 'kod',
  parametreler: [
    { turu: 'Yazı', ismi: 'ad', baslik: 'Ad', ayarlar: { zorunlu: true } },
    { turu: 'Yazı', ismi: 'soyad', baslik: 'Soyad', ayarlar: { zorunlu: true } },
    { turu: 'Yazı', ismi: 'sicilNo', baslik: 'Sicil No' },
    departmanAcilirKutu('departman', 'Departman'),
    { turu: 'Yazı', ismi: 'unvan', baslik: 'Ünvan' },
    { turu: 'Yazı', ismi: 'gorev', baslik: 'Görev' },
    { turu: 'Yazı', ismi: 'telefon', baslik: 'Telefon', ayarlar: { solSimge: '📱' } },
    { turu: 'Yazı', ismi: 'eposta', baslik: 'E-posta', ayarlar: { solSimge: '📧' } },
    { turu: 'Tarih', ismi: 'iseGirisTarihi', baslik: 'İşe Giriş Tarihi' },
  ],
};

const DEPARTMAN_HIZLI_SET = {
  id: 'hmi.departman', baslik: 'Departman', simge: '🏢', kaynak: 'kod',
  parametreler: [
    { turu: 'Yazı', ismi: 'departmanAdi', baslik: 'Departman Adı', ayarlar: { zorunlu: true } },
    { turu: 'Yazı', ismi: 'departmanKodu', baslik: 'Departman Kodu' },
    departmanAcilirKutu('ustDepartman', 'Üst Departman'),
    personelAcilirKutu('yonetici', 'Departman Yöneticisi'),
    { turu: 'Renk', ismi: 'renk', baslik: 'Renk' },
    { turu: 'Yazı Alanı', ismi: 'aciklama', baslik: 'Açıklama' },
  ],
};

const MUSTERI_HIZLI_SET = {
  id: 'hmi.musteri', baslik: 'Müşteri', simge: '🏪', kaynak: 'kod',
  parametreler: [
    { turu: 'Yazı', ismi: 'firmaAdi', baslik: 'Firma Adı', ayarlar: { zorunlu: true } },
    { turu: 'Yazı', ismi: 'yetkili', baslik: 'Yetkili Kişi' },
    { turu: 'Yazı', ismi: 'telefon', baslik: 'Telefon', ayarlar: { solSimge: '📱' } },
    { turu: 'Yazı', ismi: 'eposta', baslik: 'E-posta', ayarlar: { solSimge: '📧' } },
    { turu: 'Yazı', ismi: 'adres', baslik: 'Adres' },
    { turu: 'Yazı', ismi: 'vergiNo', baslik: 'Vergi No' },
    { turu: 'Açılır Kutu', ismi: 'kategori', baslik: 'Kategori', ayarlar: {
      secenekler: [
        { label: 'Hammadde', value: 'Hammadde' }, { label: 'Yardımcı Malzeme', value: 'Yardımcı Malzeme' },
        { label: 'Makine/Ekipman', value: 'Makine/Ekipman' }, { label: 'Hizmet', value: 'Hizmet' },
        { label: 'Lojistik', value: 'Lojistik' }, { label: 'Diğer', value: 'Diğer' },
      ],
    } },
    { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Notlar' },
  ],
};

export function personelAcilirKutu(ismi: string, baslik: string): any {
  return {
    turu: 'Açılır Kutu', ismi, baslik, ayarlar: {
      arama: true, silme: true, solSimge: '👤',
      hizliEkle: 'Personel',
      hizliEkleSetId: 'hmi.personel',
      hizliEkleKaynakSetleri: [PERSONEL_HIZLI_SET],
      itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: true, resimGoster: false },
      secenekItm: `
        ${PV_FN}
        var isim = (_pv('ad') + ' ' + _pv('soyad')).trim() || _pv('unvan') || ('Personel #' + String(scnk._id).slice(-4));
        return { value: scnk._id, label: isim, simge: '👤', aciklama: [_pv('unvan'), _pv('gorev')].filter(Boolean).join(' · ') }
      `,
      fapiAyarlar: {
        vt: 'FikoYT.sistem.hareketler',
        uygulama: 'FikoYT.sistem.hmi.yonetim',
        solSimge: { baslik: 'HMI', renkArka: '#722ed1', renkYazi: '#fff' },
        kurdela: { baslik: 'Yönetim' },
        pipeFunc: `${TR_RX_FN}
          var m = { "silindi": {"$ne":true} };
          var pipe = [ {"$match": m}, ${LOOKUP_ICERIKLER}, {"$match":{"veri.icerikler.ek._secilenSetId":"hmi.personel"}} ];
          if (rx) pipe.push({"$match":{"veri.icerikler.ek.parametreler":{"$elemMatch":{"ismi":{"$in":["ad","soyad"]},"degeri":{"$regex":rx,"$options":"i"}}}}});
          pipe.push({"$sort":{_id:-1}}, {"$limit":15}, {"$project":{_id:1,"veri.icerikler":1}});
          return pipe`,
      },
    }
  };
}

export function musteriAcilirKutu(ismi: string, baslik: string): any {
  return {
    turu: 'Açılır Kutu', ismi, baslik, ayarlar: {
      arama: true, silme: true, solSimge: '🏪',
      hizliEkle: 'Müşteri',
      hizliEkleSetId: 'hmi.musteri',
      hizliEkleKaynakSetleri: [MUSTERI_HIZLI_SET],
      itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: true, resimGoster: false },
      secenekItm: `
        ${PV_FN}
        var firma = _pv('firmaAdi');
        var yetkili = _pv('yetkili');
        return { value: scnk._id, label: firma || ('Müşteri #' + String(scnk._id).slice(-4)), simge: '🏪', aciklama: yetkili }
      `,
      fapiAyarlar: {
        vt: 'FikoYT.sistem.hareketler',
        uygulama: 'FikoYT.sistem.hmi.satis',
        solSimge: { baslik: 'HMI', renkArka: '#722ed1', renkYazi: '#fff' },
        kurdela: { baslik: 'Satış' },
        pipeFunc: `${TR_RX_FN}
          var m = { "silindi": {"$ne":true} };
          var pipe = [ {"$match": m}, ${LOOKUP_ICERIKLER}, {"$match":{"veri.icerikler.ek._secilenSetId":"hmi.musteri"}} ];
          if (rx) pipe.push({"$match":{"veri.icerikler.ek.parametreler":{"$elemMatch":{"ismi":"firmaAdi","degeri":{"$regex":rx,"$options":"i"}}}}});
          pipe.push({"$sort":{_id:-1}}, {"$limit":15}, {"$project":{_id:1,"veri.icerikler":1}});
          return pipe`,
      },
    }
  };
}

export function projeAcilirKutu(ismi: string, baslik: string, coklu = false): any {
  return {
    turu: 'Açılır Kutu', ismi, baslik, ayarlar: {
      arama: true, silme: true, solSimge: '📂', coklu,
      hizliEkle: 'Proje', hizliEkleSetId: 'hmi.proje.ekle',
      hizliEkleAlanlar: [{ ismi: 'projeAdi', baslik: 'Proje Adı', zorunlu: true }, { ismi: 'kategoriAdi', baslik: 'Kategori' }],
      itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: true, resimGoster: false },
      secenekItm: `
        ${PV_FN}
        var adi = _pv('projeAdi') || _pv('kategoriAdi') || '';
        if(!adi) adi = 'Proje #' + String(scnk._id).slice(-4);
        var durum = _pv('durum') || '';
        var musteri = _pv('musteri') || '';
        return { value: scnk._id, label: adi, simge: '📂', aciklama: [musteri, durum].filter(Boolean).join(' · ') }
      `,
      fapiAyarlar: {
        vt: 'FikoYT.sistem.hareketler',
        uygulama: 'FikoYT.sistem.uyar-dokum',
        solSimge: { baslik: 'Proje', renkArka: '#0891b2', renkYazi: '#fff' },
        pipeFunc: `${TR_RX_FN}
          var m = { "silindi": {"$ne":true} };
          var pipe = [ {"$match": m}, ${LOOKUP_ICERIKLER}, {"$match":{"veri.icerikler.ek._secilenSetId":{"$regex":"^hmi\\\\.proje"}}} ];
          if (rx) pipe.push({"$match":{"veri.icerikler.ek.parametreler":{"$elemMatch":{"ismi":"projeAdi","degeri":{"$regex":rx,"$options":"i"}}}}});
          pipe.push({"$sort":{_id:-1}}, {"$limit":20}, {"$project":{_id:1,"veri.icerikler":1}});
          return pipe`,
      },
    }
  };
}

export function siparisAcilirKutu(ismi: string, baslik: string, coklu = false): any {
  return {
    turu: 'Açılır Kutu', ismi, baslik, ayarlar: {
      arama: true, silme: true, solSimge: '🛒', coklu,
      hizliEkle: 'Sipariş', hizliEkleSetId: 'hmi.siparis',
      hizliEkleAlanlar: [{ ismi: 'siparisNo', baslik: 'Sipariş No', zorunlu: true }, { ismi: 'urunAdi', baslik: 'Başlık' }, { ismi: 'musteri', baslik: 'Müşteri' }],
      itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: true, resimGoster: false },
      secenekItm: `
        ${PV_FN}
        var no = _pv('siparisNo') || _pv('urunAdi');
        return { value: scnk._id, label: no || ('Sipariş #' + String(scnk._id).slice(-4)), simge: '🛒', aciklama: [_pv('musteri'), _pv('durum')].filter(Boolean).join(' · ') }
      `,
      fapiAyarlar: {
        vt: 'FikoYT.sistem.hareketler',
        uygulama: 'FikoYT.sistem.hmi.satis',
        solSimge: { baslik: 'HMI', renkArka: '#722ed1', renkYazi: '#fff' },
        kurdela: { baslik: 'Satış' },
        pipeFunc: `${TR_RX_FN}
          var m = { "silindi": {"$ne":true} };
          var pipe = [ {"$match": m}, ${LOOKUP_ICERIKLER}, {"$match":{"veri.icerikler.ek._secilenSetId":"hmi.siparis"}} ];
          if (rx) pipe.push({"$match":{"veri.icerikler.ek.parametreler":{"$elemMatch":{"ismi":"siparisNo","degeri":{"$regex":rx,"$options":"i"}}}}});
          pipe.push({"$sort":{_id:-1}}, {"$limit":20}, {"$project":{_id:1,"veri.icerikler":1}});
          return pipe`,
      },
    }
  };
}

export function camParcaAcilirKutu(ismi: string, baslik: string, coklu = false): any {
  return {
    turu: 'Açılır Kutu', ismi, baslik, ayarlar: {
      arama: true, silme: true, solSimge: '🔷', coklu,
      hizliEkle: 'Cam Parça', hizliEkleSetId: 'cam.parca',
      hizliEkleAlanlar: [{ ismi: 'parcaAdi', baslik: 'Parça Adı', zorunlu: true }, { ismi: 'malzeme', baslik: 'Malzeme' }, { ismi: 'adet', baslik: 'Adet' }],
      itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: true, resimGoster: false },
      secenekItm: `
        var p = (scnk.veri?.icerikler?.[0]?.ek?.parametreler || []);
        ${PV_FN}
        var adi = _pv('parcaAdi') || ('Parça #' + String(scnk._id).slice(-4));
        return { value: scnk._id, label: adi, simge: '🔷', aciklama: [_pv('malzeme'), _pv('durum')].filter(Boolean).join(' · ') }
      `,
      fapiAyarlar: {
        vt: 'FikoYT.sistem.hareketler',
        solSimge: { baslik: 'Cam', renkArka: '#0891b2', renkYazi: '#fff' },
        pipeFunc: `${TR_RX_FN}
          var m = { "silindi": {"$ne":true} };
          var pipe = [ {"$match": m}, ${LOOKUP_ICERIKLER}, {"$match":{"veri.icerikler.ek._secilenSetId":"cam.parca"}} ];
          if (rx) pipe.push({"$match":{"veri.icerikler.ek.parametreler":{"$elemMatch":{"ismi":"parcaAdi","degeri":{"$regex":rx,"$options":"i"}}}}});
          pipe.push({"$sort":{_id:-1}}, {"$limit":20}, {"$project":{_id:1,"veri.icerikler":1}});
          return pipe`,
      },
    }
  };
}

export function camKutukAcilirKutu(ismi: string, baslik: string, coklu = false): any {
  return {
    turu: 'Açılır Kutu', ismi, baslik, ayarlar: {
      arama: true, silme: true, solSimge: '🪵', coklu,
      hizliEkle: 'Kütük', hizliEkleSetId: 'cam.kutuk',
      hizliEkleAlanlar: [{ ismi: 'malzeme', baslik: 'Malzeme', zorunlu: true }, { ismi: 'en', baslik: 'En (mm)' }, { ismi: 'boy', baslik: 'Boy (mm)' }],
      itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: true, resimGoster: false },
      secenekItm: `
        ${PV_FN}
        var malzeme = _pv('malzeme');
        var olcu = [_pv('en'),_pv('boy'),_pv('yukseklik')].filter(Boolean).join('x');
        return { value: scnk._id, label: malzeme || ('Kütük #' + String(scnk._id).slice(-4)), simge: '🪵', aciklama: [olcu ? olcu+'mm' : '', _pv('durum')].filter(Boolean).join(' · ') }
      `,
      fapiAyarlar: {
        vt: 'FikoYT.sistem.hareketler',
        solSimge: { baslik: 'Cam', renkArka: '#0891b2', renkYazi: '#fff' },
        pipeFunc: `${TR_RX_FN}
          var m = { "silindi": {"$ne":true} };
          var pipe = [ {"$match": m}, ${LOOKUP_ICERIKLER}, {"$match":{"veri.icerikler.ek._secilenSetId":"cam.kutuk"}} ];
          if (rx) pipe.push({"$match":{"veri.icerikler.ek.parametreler":{"$elemMatch":{"ismi":"malzeme","degeri":{"$regex":rx,"$options":"i"}}}}});
          pipe.push({"$sort":{_id:-1}}, {"$limit":20}, {"$project":{_id:1,"veri.icerikler":1}});
          return pipe`,
      },
    }
  };
}

export function firmaAcilirKutu(ismi: string, baslik: string): any {
  return {
    turu: 'Açılır Kutu', ismi, baslik, ayarlar: {
      arama: true, silme: true, solSimge: '🏪',
      hizliEkle: 'Firma',
      hizliEkleSetId: 'hmi.musteri',
      hizliEkleKaynakSetleri: [MUSTERI_HIZLI_SET],
      itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: true, resimGoster: false },
      secenekItm: `
        ${PV_FN}
        var firma = _pv('firmaAdi');
        var yetkili = _pv('yetkili');
        var setId = ic?.ek?._secilenSetId || '';
        var simge = setId === 'hmi.tedarikci' ? '🏭' : '🏪';
        return { value: scnk._id, label: firma || ('Firma #' + String(scnk._id).slice(-4)), simge: simge, aciklama: yetkili }
      `,
      fapiAyarlar: {
        vt: 'FikoYT.sistem.hareketler',
        uygulama: 'FikoYT.sistem.hmi.satis',
        solSimge: { baslik: 'HMI', renkArka: '#722ed1', renkYazi: '#fff' },
        kurdela: { baslik: 'Satış' },
        pipeFunc: `${TR_RX_FN}
          var m = { "silindi": {"$ne":true} };
          var pipe = [ {"$match": m}, ${LOOKUP_ICERIKLER}, {"$match":{"veri.icerikler.ek._secilenSetId":{"$in":["hmi.musteri","hmi.tedarikci"]}}} ];
          if (rx) pipe.push({"$match":{"veri.icerikler.ek.parametreler":{"$elemMatch":{"ismi":"firmaAdi","degeri":{"$regex":rx,"$options":"i"}}}}});
          pipe.push({"$sort":{_id:-1}}, {"$limit":15}, {"$project":{_id:1,"veri.icerikler":1}});
          return pipe`,
      },
    }
  };
}
